var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 55,
    viewBox: "0 0 148 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_386_2116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1887 42.0145C19.1887 50.3529 16.4181 53.9584 10.2158 53.9584C8.69092 53.9584 6.41899 53.8307 4.69328 52.2385C2.82507 50.5135 1.80191 46.9509 1.79004 46.3443L0 49.2315C0.321593 49.9089 1.78113 51.9791 2.73502 52.848C5.19793 55.1018 8.3911 54.999 10.0931 54.999C17.655 54.999 21.8485 50.6512 21.8485 41.9546V11.7255H19.1887V42.0145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.042 11.6796H135.535V55H138.042V11.6796Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.806 52.7293L107.654 11.6796H106.174H105.101V12.2353V55H106.174V14.2286L128.18 55H129.806H130.88V54.7186V11.6796H129.806V52.7293Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9393 11.6796H97.5346L82.6612 52.884L67.7908 11.6796H65.7138H64.9152H64.6401V55H65.7138V13.8924L80.5555 55H83.0402L83.055 54.9601L83.2341 54.4652L97.9393 13.7338V55H100.446V11.6796H98.6805H97.9393Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.536 54.702C147.846 54.0415 148.377 52.4355 147.722 51.1147C147.066 49.794 145.474 49.2588 144.164 49.9193C142.854 50.5798 142.323 52.1859 142.978 53.5066C143.633 54.8273 145.226 55.3625 146.536 54.702Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1816 11.6796H42.0001L41.8715 12.0338L26.3608 55H27.5423L30.1487 47.7799C32.1792 45.1511 36.9625 40.1418 44.7362 38.0408C47.1516 37.3883 49.2503 37.5479 51.1106 37.6417L57.3822 55H60.0539L44.4096 11.6796H43.1816ZM31.0096 45.3935L42.4623 13.6679L50.6683 36.4046C40.3981 36.1233 34.0553 41.7151 31.0096 45.3935Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0826 6.02886C49.3877 4.27497 48.6268 1.279 48.0826 0C45.4742 6.1386 41.5597 7.673 39.929 7.673C42.1039 7.85558 46.7784 7.78175 48.0826 6.02886Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_2116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 55,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ffbc99c588815298015747b7821976ad.svg";
export { ForwardRef as ReactComponent };